import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
// import axios from "axios";
import API from "../services/api";

export default function ProtectedRoute({ children }) {

  const [auth, setAuth] = useState(null);

useEffect(() => {
  API.get("/auth/check.php")
    .then(res => {
      setAuth(res.data.authenticated);
    })
    .catch(err => {
      console.log(err);
    });
}, []);


  if(auth === null) return <div>Loading...</div>;

  return auth ? children : <Navigate to="/admin/login" />;
}
